const input = {
    username: 'Nume de utilizator',
    password: 'Parolă',
    email: 'Email',
    phone_number: 'Număr de telefon',
    confirm_password: 'Confirmă parola',
    search_region_code: 'Caută codul regiunii',
    backup_code: 'Cod de rezervă',
};
export default Object.freeze(input);
